export default "__VITE_ASSET__CwojNFtr__"